<template>
    <Carousel :value="datas" :page="initialIndex" :numVisible="numVisible" :numScroll="numScroll" :orientation="direction" :verticalViewPortHeight="height" :responsiveOptions="responsiveOptions" :circular="loop" :autoplayInterval="interval" v-if="datas.length">
        <template #header>
            <slot name="title"></slot>
        </template>
        <template #item="slotProps">
            <div :class="{ 'tw-list-view-item-highlight': slotProps.data === data_source.current }" style="margin-right: 8px;" @click="onClick(slotProps.data)">
                <slot v-bind:data="slotProps.data" v-bind:columns="data_source.columns">

                </slot>
            </div>
        </template>
    </Carousel>
</template>

<script>
import { ref, computed } from 'vue'
import Carousel from 'primevue/carousel';

export default {
    name: 'tw-carousel',
    components: {
        Carousel
    },
    setup(props) {
        const designMode = window.site && window.site.designMode;

        const datas = computed(() => {
            let result = props?.data_source?.datas ?? []
            if (designMode && !result.length) {
                // 设计模式时需要增加一个空行用于设计插槽里的内容
                result = [{}]
            }
            return result
        })

        const onChange = function(index) {
            // eslint-disable-next-line vue/no-mutating-props
            props.data_source.current = props.data_source.datas[index]
        }

        const responsiveOptions = ref([
            {
				breakpoint: '1024px',
				numVisible: 3,
				numScroll: 3
			},
			{
				breakpoint: '600px',
				numVisible: 2,
				numScroll: 2
			},
			{
				breakpoint: '480px',
				numVisible: 1,
				numScroll: 1
			}
        ])

        const onClick = function(data) {
            // eslint-disable-next-line vue/no-mutating-props
            props.data_source.current = data
        }

        return {
            datas,
            onChange,
            onClick,
            responsiveOptions
        }
    },
    props: {
        data_source: {
            type: Object,
            default: function() {
                return {
                    // 需要提供一个空行，否则设计器无法设计插槽的内容
                    datas: [{}],
                    columns: []
                }
            }
        },
        numVisible: Number,
        numScroll: Number,
        height: String,
        "initial-index": {
            type: Number,
            default: 0
        },
        interval: {
            type: Number,
            default: 3000
        },
        loop: {
            type: Boolean,
            default: true
        },
        direction: {
            type: String,
            default: 'horizontal'
        },
        bgColor: {
            type: String,
            default: ''
        }
    }
}
</script>
